import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRooms } from '../hooks/useRooms';
import PublicRoomsList from './PublicRoomsList';

interface PublicRoomsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PublicRoomsModal: React.FC<PublicRoomsModalProps> = ({ isOpen, onClose }) => {
  const { publicRooms, fetchPublicRooms } = useRooms();
  const navigate = useNavigate();
  
  // Actualizar la lista de salas cada vez que se abre el modal
  useEffect(() => {
    if (isOpen) {
      console.log('Modal de salas públicas abierto, actualizando lista...');
      fetchPublicRooms();
    }
  }, [isOpen, fetchPublicRooms]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div 
          className="fixed inset-0 transition-opacity" 
          aria-hidden="true"
          onClick={onClose}
        >
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm"></div>
        </div>

        <div 
          className="inline-block align-bottom rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-5xl sm:w-full relative"
          style={{ backgroundColor: 'var(--card-bg)' }}
        >
          {/* Decoración visual */}
          <div className="absolute top-0 right-0 -mt-10 -mr-10 w-32 h-32 rounded-full blur-3xl opacity-30" 
              style={{ backgroundColor: 'var(--accent-color)' }}></div>
          <div className="absolute bottom-0 left-0 -mb-10 -ml-10 w-40 h-40 rounded-full blur-3xl opacity-30" 
              style={{ backgroundColor: 'var(--accent-color)' }}></div>
          
          <div className="p-6 sm:p-8 relative">
            <div className="flex justify-between items-center mb-8 border-b pb-4" style={{ borderColor: 'var(--border-color)' }}>
              <div className="flex items-center">
                <div className="w-12 h-12 rounded-full flex items-center justify-center mr-4 shadow-lg" 
                    style={{ backgroundColor: 'var(--button-bg)' }}>
                  <svg className="w-6 h-6" style={{ color: 'var(--accent-color)' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <h2 className="text-3xl font-bold" style={{ color: 'var(--text-color)' }}>Salas públicas</h2>
                  <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>Únete a las salas que están activas en este momento</p>
                </div>
              </div>
              <button
                onClick={onClose}
                className="rounded-full p-2 hover:bg-gray-500/10 transition-colors"
                style={{ color: 'var(--text-secondary)' }}
              >
                <svg 
                  className="w-6 h-6"
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="max-h-[60vh] overflow-y-auto p-1 mb-6">
              <PublicRoomsList className="px-1" />
            </div>

            <div className="flex justify-end pt-4 border-t" style={{ borderColor: 'var(--border-color)' }}>
              <button
                type="button"
                onClick={onClose}
                className="themed-button px-6 py-3 rounded-xl text-sm font-medium transition-all"
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--button-hover)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--button-bg)';
                }}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicRoomsModal; 